// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-vermais[data-v-4e1cc90d]{display:none}@media screen and (max-width:1023px){.btn-vermais[data-v-4e1cc90d]{display:block}}", ""]);
// Exports
module.exports = exports;
